const featureFlags = {
  get hideCallIndicator() {
    return !!window.__amp_feature_flags.hide_call_indicator;
  },
  get customerSituation() {
    return !!window.__amp_feature_flags.customer_situation;
  },
  get carrierLenderDirectory() {
    return !!window.__amp_feature_flags.carrier_lender_directory;
  },
  get showPeopleTable() {
    return !!window.__amp_feature_flags.show_people_table;
  },
  get dynamicTips() {
    return (
      !!window.__amp_feature_flags.dynamic_tip_on_summary ||
      !!window.__amp_feature_flags.dynamic_tip_on_data_collection ||
      !!window.__amp_feature_flags.dynamic_tip_on_quotes ||
      !!window.__amp_feature_flags.life_insurance_pitch
    );
  },
  get dynamicTipOnSummary() {
    return !!window.__amp_feature_flags.dynamic_tip_on_summary;
  },
  get dynamicTipOnDataCollection() {
    return !!window.__amp_feature_flags.dynamic_tip_on_data_collection;
  },
  get dynamicTipOnQuotes() {
    return !!window.__amp_feature_flags.dynamic_tip_on_quotes;
  },
  get lifeInsurancePitch() {
    return !!window.__amp_feature_flags.life_insurance_pitch;
  },
  get cstGuidedSellingExperience() {
    return !!window.__amp_feature_flags.cst_guided_selling_experience;
  },
  get salesDashboardColumnsVisibility() {
    return !!window.__amp_feature_flags.sales_dashboard_columns_visibility;
  },
  get sendDocuments() {
    return !!window.__amp_feature_flags.send_documents;
  },
  get vehicleQuoteTierVariants() {
    return !!window.__amp_feature_flags.vehicle_quote_tier_variants;
  },
  get marketingEmailsInFeed() {
    return !!window.__amp_feature_flags.marketing_emails_in_feed;
  },
  get vehicleCoverageTiers() {
    return !!window.__amp_feature_flags.vehicle_coverage_tiers;
  },
  get requestPolicyDocuments() {
    return !!window.__amp_feature_flags.request_policy_documents;
  },
  get earthquakeQuoting() {
    return !!window.__amp_feature_flags.earthquake_quoting;
  },
  get removeRelatedPerson() {
    return !!window.__amp_feature_flags.remove_related_person;
  },
  get customerAssetsAddHome() {
    return !!window.__amp_feature_flags.customer_assets_add_home;
  }
};

export default featureFlags;
